"use strict";
import React from "react";
import Account from "../../api/account";
import Address from "./address";
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import generalFormatter from "../../formatters/general";
import LineItems from "../carrier_invoice/line_items";
import PaymentStrategyEditor from "./payment_strategy_editor";
import PossibleAdjustments from "./possible_adjustments";
function onPaymentAmountDragOver(e) {
  e.preventDefault();
}
function onPaymentAmountDrop(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
  e.preventDefault();
  e.target.value = e.dataTransfer.getData("text/plain");
  e.target.dispatchEvent(new Event("input", { bubbles: true }));
}
function shouldShowLineItems(props) {
  return Account.shouldShowLineItems() || props.creatingLoad;
}
function lineItems(props) {
  if (shouldShowLineItems(props)) {
    return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      LineItems,
      {
        carrierInvoice: props.carrierInvoice,
        payment: props.payment,
        load: props.load,
        creatingLoad: props.creatingLoad,
        invoiceChangeComplete: props.invoiceChangeComplete
      }
    ));
  }
}
function remitToValidationMessage(props) {
  if (!Account.currentSettings().show_carrier_invoice_remit_to_validation) {
    return "";
  }
  switch (props.carrierInvoice.remit_to_validation_result) {
    case "no_tms_address":
      var message = "No pay-to address found in TMS.";
      var className = "warning";
      break;
    case "remit_to_zips_match":
      var message = "Pay-to zip codes match.";
      var className = "success";
      break;
    case "check_factor_remit_to":
      var message = "Pay-to may not match factored invoice.";
      var className = "error";
      break;
    case "check_remit_to":
      var message = "Pay-to may not match invoice.";
      var className = "error";
      break;
    case "cant_find_remit_to_zip":
      var message = "Can't find pay-to zip code.";
      var className = "error";
      break;
    case "triumphpay_remit_to":
      var message = "Pay via TriumphPay";
      var className = "success";
      break;
    case "triumphpay_inconclusive":
      var message = "Pay via TriumphPay";
      var className = "";
      break;
    default:
      return "";
  }
  className += " load-detail__remit_to_validation";
  return /* @__PURE__ */ React.createElement("div", { className }, message);
}
function remitToUpdateReminder(props) {
  if (Account.currentSettings().use_triumph_pay_carrier_remit_to && props.carrierInvoice.remit_to_validation_result != "remit_to_zips_match") {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__remit_to_update_reminder" }, "If needed, send NOA to TriumphPay or update remittance in your system. Updates may not appear immediately.");
  }
}
function possiblePossibleAdjustments(props) {
  if (props.carrierInvoice.quickpay_disposition === "not_applied_to_invoice") {
    return /* @__PURE__ */ React.createElement(
      PossibleAdjustments,
      {
        expectedTotal: tmsTotal(props),
        load: props.load,
        carrierInvoice: props.carrierInvoice
      }
    );
  }
}
function tmsTotal(props) {
  if (props.load.load.carrier_charge) {
    return parseFloat(props.load.load.carrier_charge);
  }
  return 0;
}
function payToLabel(props, state) {
  if (Account.currentSettings().use_triumph_pay_carrier_remit_to && props.carrier.payment_address_source === "triumphpay") {
    return "TriumphPay Payee";
  }
  if (state.editing) {
    return Account.carrierTerm() + " Payment Settings";
  }
  if (!allowEditingCarrierPaymentStrategy(props)) {
    return Account.carrierTerm() + " Remittance Address";
  }
  switch (props.carrier.payment_strategy) {
    case "direct":
      return "Pay Direct to " + Account.carrierTerm();
    case "factor":
      return "Pay Via Factor";
    default:
      return "Pay To";
  }
}
function carrierForTypeahead(props, state) {
  return state.carrier || props.carrier;
}
function cancelEditingCarrier(props) {
  var _a;
  (_a = props.onCarrierChanged) == null ? void 0 : _a.call(props, null);
}
function updateField(props, field) {
  return (event) => {
    var _a;
    (_a = props.updatePaymentField) == null ? void 0 : _a.call(props, field, event.target.value);
  };
}
function allowEditingCarrierPaymentStrategy(props) {
  return Account.currentSettings().allow_editing_carrier_payment_strategy && props.carrier.payment_strategy != "triumphpay";
}
const PaymentInformation = React.createClass({
  getInitialState: function() {
    return {};
  },
  input: function(field, type) {
    if (field == "payOn") {
      return /* @__PURE__ */ React.createElement(
        "input",
        {
          type,
          value: this.props.payment[field],
          onChange: updateField(this.props, field),
          disabled: this.props.readOnly
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "input",
        {
          type,
          disabled: this.props.readOnly,
          valueLink: this.myLinkState(field),
          onBlur: this.props.invoiceChangeComplete,
          onKeyPress: this.props.keyPressNotifier(field),
          onDragOver: onPaymentAmountDragOver,
          onDrop: onPaymentAmountDrop,
          placeholder: "Payment Amount"
        }
      );
    }
  },
  myLinkState: function(field) {
    var component = this;
    var value = this.state[field] || this.props.payment["amount"];
    return {
      value,
      requestChange: function(value2) {
        var state = {};
        state[field] = value2;
        component.setState(state);
        var vl = value2 ? generalFormatter.cleanAmount(value2).toString() : "";
        component.props.updatePaymentField(field, vl);
        component.props.invoiceFieldChanged(field, vl);
      }
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "PaymentInformation" }, /* @__PURE__ */ React.createElement("div", { className: "row load-detail__invoice-area" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Payment Amount"), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.input("amount_to_pay", "text"), possiblePossibleAdjustments(this.props)))), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, this.paymentDueOnInput()), lineItems(this.props), /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-carrier-container" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "load-detail__name-wrapper",
        style: { display: "flex", justifyContent: "space-between" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "load-detail__name-container" }, /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "load-detail__invoice-label",
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: "The " + Account.carrierTerm() + " who the payment will be sent to"
        },
        "Invoice ",
        Account.carrierTerm()
      ), /* @__PURE__ */ React.createElement("label", { className: "load-detail__invoice-name-label show_for_reskin" }, Account.carrierTerm(), " name"), this.invoiceCarrierOrEditor()),
      this.props.children
    )), /* @__PURE__ */ React.createElement("div", { className: "small-5 column load-detail__invoice_address_container" }, /* @__PURE__ */ React.createElement("label", null, payToLabel(this.props, this.state), this.possibleEditAddressLink()), /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice_address" }, this.addressOrEditor(), remitToValidationMessage(this.props), remitToUpdateReminder(this.props))))));
  },
  paymentDueOnInput: function() {
    if (Account.carrierInvoiceCanModifyPaymentDueOn()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", null, "Payment Due On"), this.input("payOn", "date"));
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  invoiceCarrierOrEditor: function() {
    if (this.state.editingCarrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-name-editor" }, /* @__PURE__ */ React.createElement(
        CarrierTypeAhead,
        {
          carrier: carrierForTypeahead(this.props, this.state),
          onSelectCarrier: this.carrierWasSet,
          onClearCarrier: () => cancelEditingCarrier(this.props)
        }
      ));
    }
    return /* @__PURE__ */ React.createElement("h6", null, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: this.props.carrier.id }), "\xA0", this.possibleCarrierEditorLink());
  },
  possibleCarrierEditorLink: function() {
    if (!this.props.readOnly) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.startEditingCarrier }, /* @__PURE__ */ React.createElement("i", { className: "fi-pencil" }));
    }
  },
  carrierWasSet: function(carrier) {
    this.setState({ carrier });
    this.props.onCarrierChanged(carrier);
  },
  startEditingCarrier: function() {
    this.setState({ editingCarrier: true });
  },
  addressOrEditor: function() {
    if (this.state.editing) {
      return /* @__PURE__ */ React.createElement(
        PaymentStrategyEditor,
        {
          carrier: this.props.carrier,
          onSave: this.savePaymentStrategy
        }
      );
    }
    return /* @__PURE__ */ React.createElement(Address, { source: this.props.carrier.payment_address });
  },
  saveAddress: function(address) {
    return this.props.saveAddress(address).then(() => {
      this.setState({ editing: false });
    });
  },
  savePaymentStrategy: function(paymentStrategy, details) {
    return this.props.savePaymentStrategy(paymentStrategy, details).then(() => this.setState({ editing: false }));
  },
  possibleEditAddressLink: function() {
    if (this.props.canEditAddress && !this.props.readOnly && allowEditingCarrierPaymentStrategy(this.props)) {
      if (this.state.editing) {
        return /* @__PURE__ */ React.createElement("a", { className: "right payment-info__edit", onClick: this.cancelEditing }, "cancel");
      }
      return /* @__PURE__ */ React.createElement("a", { className: "right payment-info__edit", onClick: this.startEditing }, "edit");
    }
  },
  startEditing: function() {
    this.setState({ editing: true });
  },
  cancelEditing: function() {
    this.setState({ editing: false });
  }
});
export default PaymentInformation;
